import { useState, useEffect } from 'react';
import axios from 'axios';

export function useFirstAidGuide(guideId, open) {
  const [guide, setGuide] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!guideId || !open) {
      setGuide(null);
      setError(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    setGuide(null);
    axios.get(`/first-aid-guides/${guideId}`)
      .then(res => setGuide(res.data))
      .catch(() => setError('Failed to load First Aid Guide.'))
      .finally(() => setLoading(false));
  }, [guideId, open]);

  return { guide, loading, error };
} 